/* eslint-disable */
import axios from "axios";

export const mergePhotoRequest = async (requestBody: any) => {
  const baseUrl = process.env.REACT_APP_SERVER_URL;
  const mergedApiUrl = `${baseUrl}/api/merge_photo`;
  const mergedPhotoInfo = await axios.post(mergedApiUrl, requestBody);
  return mergedPhotoInfo.data;
};
